module.exports = __webpack_public_path__ + "static/media/greenbee.54be04c8.svg";